import axios from "axios";

const URL =
  process.env.REACT_APP_API_BASE_PROD_URL ||
  process.env.REACT_APP_API_BASE_URL ||
  "http://localhost:3002";

/**
 * Upload patients.csv and accounts.csv to the transform endpoint.
 * @param {File} patientsFile
 * @param {File} accountsFile
 * @returns {Promise<Object>} { patientCount, accountCount, linkedCount, exceptions }
 */
/**
 * Fetch the practices available to the current user for migration.
 * @returns {Promise<Array>}
 */
export async function getMigrationPractices() {
  const token = sessionStorage.getItem("user");
  const response = await axios.get(`${URL}/datamigration/practices`, {
    headers: { authorization: `Bearer ${token}` },
  });
  return response.data;
}

export async function transformCSVs(patientsFile, accountsFile, practiceNumber) {
  const formData = new FormData();
  formData.append("patients", patientsFile);
  formData.append("accounts", accountsFile);
  formData.append("practiceNumber", practiceNumber);

  const token = sessionStorage.getItem("user");
  const response = await axios.post(`${URL}/datamigration/transform`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      authorization: `Bearer ${token}`,
    },
  });
  return response.data;
}

/**
 * Start the enrichment process (returns immediately; progress via Socket.IO).
 * @returns {Promise<{ started: boolean }>}
 */
export async function startEnrichment() {
  const token = sessionStorage.getItem("user");
  const response = await axios.post(
    `${URL}/datamigration/enrich`,
    {},
    { headers: { authorization: `Bearer ${token}` } },
  );
  return response.data;
}

/**
 * Download a JSON file and trigger a browser download.
 * @param {'enriched_patients'|'enriched_accounts'|'transformed_patients'|'transformed_accounts'} type
 */
export async function downloadFile(type) {
  const token = sessionStorage.getItem("user");
  const response = await axios.get(`${URL}/datamigration/download/${type}`, {
    headers: { authorization: `Bearer ${token}` },
    responseType: "blob",
  });

  const blob = new Blob([response.data], { type: "application/json" });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${type}.json`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

/**
 * Get the current migration session status.
 * @returns {Promise<{ hasTransformed: boolean, hasEnriched: boolean, summary: Object|null }>}
 */
export async function getMigrationStatus() {
  const token = sessionStorage.getItem("user");
  const response = await axios.get(`${URL}/datamigration/status`, {
    headers: { authorization: `Bearer ${token}` },
  });
  return response.data;
}

export async function transformQB(xlsxFile, practiceNumber) {
  const formData = new FormData();
  formData.append("xlsxFile", xlsxFile);
  formData.append("practiceNumber", practiceNumber);
  const token = sessionStorage.getItem("user");
  const response = await axios.post(`${URL}/datamigration/transform-qb`, formData, {
    headers: { "Content-Type": "multipart/form-data", authorization: `Bearer ${token}` },
  });
  return response.data;
}

export async function confirmPreview() {
  const token = sessionStorage.getItem("user");
  const response = await axios.post(
    `${URL}/datamigration/confirm-preview`,
    {},
    { headers: { authorization: `Bearer ${token}` } },
  );
  return response.data;
}

export async function abortMigration() {
  const token = sessionStorage.getItem("user");
  const response = await axios.post(
    `${URL}/datamigration/abort`,
    {},
    { headers: { authorization: `Bearer ${token}` } },
  );
  return response.data;
}
